// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".triple-card--mmbWl a:hover{text-decoration:none}.triple-card--mmbWl .card{border:0;border-radius:10px}.triple-card--mmbWl .card:hover{box-shadow:0 0 30px rgba(36,40,47,.1)}.triple-card--mmbWl .card-title--E_ar6,.triple-card--mmbWl .card-text--kbmcW,.triple-card--mmbWl .card-cta--HU3Sc{color:#24282f}.triple-card--mmbWl .card-text--kbmcW p{font-size:1.25rem}.triple-card--mmbWl .card-title--E_ar6{font-size:.75rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"triple-card": "triple-card--mmbWl",
	"card-title": "card-title--E_ar6",
	"card-text": "card-text--kbmcW",
	"card-cta": "card-cta--HU3Sc"
};
export default ___CSS_LOADER_EXPORT___;
